export const MetalCaratOptions = [
  { value: '14K', label: '14K' },
  { value: '18K', label: '18K' },
  { value: '20K', label: '20K' },
  { value: '22K', label: '22K' },
  { value: '24K', label: '24K' }
]

export const MetalColorOptions = [
  { value: 'yellow', label: 'Yellow' },
  { value: 'white', label: 'White' },
  { value: 'pink', label: 'Pink' }
]
